import { Tracker } from './Tracker';

class TrackerManager
{
  constructor()
  {
    this.time_online = 0;
    this.time_online_total = 0;
  }

  init()
  {
    if (!window.dataLayer)
    {
      console.warn('Faking GTM dataLayer');
      window.dataLayer = [];
      window.gtag = () =>
      {};

      window.lintrk = () =>
      {};
    }

    const buttons = document.querySelectorAll('.button');

    for (let i = 0; i < buttons.length; i++)
    {
      const button = buttons[i];
      button.addEventListener('click', this.on_button_click.bind(this, button));
    }
  }

  on_button_click(button, event)
  {
    if (button.dataset.track)
    {
      // console.log(button.dataset.track);

      Tracker.track('button_clicked', {
        button_name: button.dataset.track
      });

    // this.track({
    //   event: 'ga4Event',
    //   event_name: 'us_button_click',
    //   us_button_click: {
    //     interaction: button.dataset.interaction,
    //     event_category: 'Click',
    //     event_action: button.dataset.eventAction,
    //     event_label: 'Ultimate Stage'
    //   }
    // });
    }
  }

  update()
  {
    this.time_online += 0.0016;
    this.time_online_total += 0.0016;

    if (this.time_online > 60) // 5 min
    {
      this.time_online = 0;

      // console.log('user ping');

      Tracker.track('user_ping', this.time_online_total);
    }
  }
}

const tracker_manager = new TrackerManager();
export { tracker_manager as TrackerManager };
